<template>
  <div>
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <div class="track_content_style">
      <div class="express_name_style">
        <div class="company_style">物流公司</div>
        <div class="company_layout_style">
          <div class="company_text_style">【{{ expressName }}】</div>
          <div class="express_num_style">
            {{ expressNum }}
          </div>
          <img
            @click="copy_click"
            class="copy_style"
            data-clipboard-target=".express_num_style"
            src="../assets/img/复制icon.png"
            alt=""
          />
        </div>
      </div>
      <div class="timeline_style">
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in track_list"
            :key="index"
            :timestamp="item.ftime"
            :type="index == 0 ? 'primary' : 'info'"
          >
            <!-- placement="top" -->
            <!-- <el-card>
              <div style="font-size: 14px; font-size: 14px">
                {{ item.context }}
              </div>
            </el-card> -->{{ item.context }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Clipboard from "clipboard";
import { Toast } from "vant";

export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {
      expressName: this.$route.query.expressName,
      expressNum: this.$route.query.expressNum,
      track_list: [],
    };
  },
  mounted() {
    this.axios
      .get("/track", {
        params: {
          expressNum: this.expressNum,
        },
      })
      .then((res) => {
        if (res.data.code == 200) {
          this.track_list = JSON.parse(res.data.data);
        }
      });
  },
  methods: {
    copy_click() {
      const clipboard = new Clipboard(".copy_style");
      clipboard.on("success", function (e) {
        Toast.success("已复制");
        e.clearSelection();
      });
      clipboard.on("error", function (e) {
        Toast.success("复制失败");
      });
    },
    onClickLeft() {
      this.$router.push({
        path: "/mobileOrder",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.track_content_style {
  background: #f6f7f9;
  padding: 20px 15px;
}
.company_style {
  font-size: 16px;
  font-weight: bold;
  color: #202f3b;
}
.express_name_style {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  padding: 15px 18px;
}
.company_layout_style {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #8a8a8a;
}
.timeline_style {
  background: #fff;
  border-radius: 8px;
  padding: 20px 23px 0 20px;
}
</style>